import * as React from "react";
import Spinner from '../../../common/components/spinner/spinner';
import Translate from '../../../common/functions/translate';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import LaboratoryResultsService from '../../../services/userLaboratoryResultService';
import AuthService from '../../../services/authService';
import Growl from '../../../common/components/alertMessage/growl';
import { UserForGridModel } from "../../../models/user";
import ConfirmDialog from '../../../common/components/confirmDialog/confirmDialog';
import { UserLaboratoryResultModel } from '../../../models/user/userLaboratoryResultModel';
import { LaboratoryResultTypeModel } from '../../../models/user/laboratoryResultTypeModel';
import LaboratoryResultsList from './laboratoryResultsList';
import LaboratoryResultAddEditDialog from './laboratoryResultsAddEditComponent';
import { LaboratoryTestType, TimePresetType } from "../../../common/enums";
import { connect } from 'react-redux';
import { enumToDropdownArray, fomatDateTimeAsString, fomatDateTimeAsStringWithLang } from '../../../common/functions/helperFunctions';
import { UserLaboratoryResultFilterModel } from '../../../models/user/userLaboratoryResultFilterModel';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import CSSTransition from 'react-transition-group/CSSTransition';
import Dialog from '@material-ui/core/Dialog';
import * as Modal from '../../../common/modalDialog';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import ExpandingList from '../../../common/components/expandingList/expandingList';
import InputLabel from '@material-ui/core/InputLabel';
import * as Constants from '../../../common/constants';
import * as HelperFunctions from "../../../common/functions/helperFunctions";
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import { faTimes, faFilter } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile, faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { PersonalLaboratoryResultModel } from '../../../models/user/personalLaboratoryResultModel';
import { DropdownModel } from "../../../models/dropdownModel";
import FileSaver from 'file-saver';
import FileService from "../../../services/fileService";

interface IProps {
	history: any;
	location: any;
	userId: number;
	lang: string;
}

interface IState {
	isLoading: boolean;
	totalRecordsCount: number;
	users: Array<UserForGridModel>;
	isVisibleDialog: boolean;
	currentlaboratoryResult: UserLaboratoryResultModel;
	userLaboratoryResults: Array<UserLaboratoryResultModel>;
	dialogHeader: string;
	isVisibleConfirmDialog: boolean;
	deleteValidationMessage: string;
	selectedLaboratoryResultId: number;
	first: number;
	rows: number;
	totalRecords: number;
	laboratoryResultType: Array<LaboratoryResultDropdownModel>;
	filters: UserLaboratoryResultFilterModel;
	isVisibleView: boolean;
	expandedLaboratoryResult: Array<UserLaboratoryResultModel>;
	expanded: string;
	drawer: boolean;
	tabActiveIndex: number;
	currentFilters: UserLaboratoryResultFilterModel,
	selectedLaboratoryResultValue: number,
	currentlaboratoryResultValue: number,
	selectedTime: number;
	canChooseDates: boolean;
	timeDropdown: Array<DropdownModel>;
	filterByDates: boolean
}

class UserlaboratoryResultComponent extends React.Component<IProps, IState> {

	laboratoryResultsService = new LaboratoryResultsService();
	authService = new AuthService();
	fileService = new FileService();
	growl: any;

	constructor(props: IProps) {
		super(props);
		this.state = {
			isLoading: false,
			totalRecordsCount: 0,
			users: new Array<UserForGridModel>(0),
			isVisibleDialog: false,
			currentlaboratoryResult: new UserLaboratoryResultModel(),
			userLaboratoryResults: new Array<UserLaboratoryResultModel>(),
			dialogHeader: '',
			isVisibleConfirmDialog: false,
			deleteValidationMessage: '',
			selectedLaboratoryResultId: 0,
			first: 0,
			rows: 10,
			totalRecords: 0,
			laboratoryResultType: new Array<LaboratoryResultDropdownModel>(0),
			filters: new UserLaboratoryResultFilterModel(),
			currentFilters: new UserLaboratoryResultFilterModel(),
			isVisibleView: false,
			expandedLaboratoryResult: new Array<UserLaboratoryResultModel>(0),
			expanded: '',
			drawer: false,
			tabActiveIndex: 0,
			selectedLaboratoryResultValue: 0,
			currentlaboratoryResultValue: 0,
			timeDropdown: Array<DropdownModel>(0),
			selectedTime: 1,
			canChooseDates: false,
			filterByDates: false
		};
	}

	componentDidMount() {
		window.addEventListener('scroll', this.onScroll);
		this.getlaboratoryResults(true);
	}

	laboratoryResultEnumToDropdownArray(enumName, isSystem: boolean) {
		let enumAsArray: Array<LaboratoryResultDropdownModel> = [];
		for (var n in enumName) {
			if (typeof enumName[n] === 'number') {
				enumAsArray.push({ value: +enumName[n], label: Translate(n), isSystem: isSystem });
			}
		}
		return enumAsArray;
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.onScroll);
	}

	onScroll = () => {
		let scrollY = window.scrollY ? window.scrollY : window.pageYOffset;
		if (window.innerHeight + scrollY >= document.body.offsetHeight - 250 &&
			this.state.totalRecords > this.state.userLaboratoryResults.length && !this.state.isLoading) {
			this.paginatorClick({ first: this.state.first + this.state.rows }, false);
		}
	};



	getlaboratoryResults(isInit: boolean) {
		this.setState({
			isLoading: true,
			laboratoryResultType: new Array<LaboratoryResultDropdownModel>(0)
		});

		if (this.authService.isAuthenticated()) {
			let filter: UserLaboratoryResultFilterModel = new UserLaboratoryResultFilterModel();
			filter.userLaboratoryResultType = this.state.filters.userLaboratoryResultType;

			if (this.state.filterByDates && this.state.filters.startDate) {
				filter.startDate = HelperFunctions.fomatDateTimeAsString(new Date(this.state.filters.startDate));
			}

			if (this.state.filterByDates && this.state.filters.endDate) {
				filter.endDate = HelperFunctions.fomatDateTimeAsString(new Date(this.state.filters.endDate));
			}

			if (this.state.selectedLaboratoryResultValue && this.state.selectedLaboratoryResultValue > 0) {
				let cond: LaboratoryResultTypeModel = new LaboratoryResultTypeModel();
				if (this.state.selectedLaboratoryResultValue > 1000) {
					cond.isSystemType = false;
					cond.laboratoryResultTypeId = this.state.selectedLaboratoryResultValue - 1000;
				}
				else {
					cond.isSystemType = true;
					cond.laboratoryResultTypeId = this.state.selectedLaboratoryResultValue;
				}
				filter.userLaboratoryResultType = cond;
			}

			let userId = this.props.userId ? this.props.userId : this.authService.getUserId();

			this.laboratoryResultsService.getAllLaboratoryResults(this.state.first, this.state.rows, filter).then(
				(data: any) => {
					if (data) {
						let personalCond: Array<PersonalLaboratoryResultModel> = new Array<PersonalLaboratoryResultModel>(0);
						personalCond = data.personallaboratoryResults;
						let laboratoryResultType: Array<LaboratoryResultDropdownModel> = [{ label: Translate('Select'), value: 0, isSystem: false }];
						laboratoryResultType.push(...this.laboratoryResultEnumToDropdownArray(LaboratoryTestType, true));

						if (personalCond && personalCond.length > 0) {
							for (let cond of personalCond) {
								let laboratoryResult: LaboratoryResultDropdownModel = new LaboratoryResultDropdownModel();
								laboratoryResult.value = cond.personalLaboratoryResultId + 1000;
								laboratoryResult.label = cond.personalLaboratoryResultName;
								laboratoryResult.isSystem = false
								laboratoryResultType.push(laboratoryResult);
							}
						}

						if (isInit) {
							this.setState({
								isLoading: false,
								userLaboratoryResults: [...data.userLaboratoryResults],
								totalRecords: data.totalRecords,
								laboratoryResultType: this.state.laboratoryResultType.concat(laboratoryResultType)
							});
						}
						else {
							this.setState({
								isLoading: false,
								userLaboratoryResults: [...this.state.userLaboratoryResults, ...data.userLaboratoryResults],
								totalRecords: data.totalRecords,
								laboratoryResultType: this.state.laboratoryResultType.concat(laboratoryResultType)
							});
						}
					}
				})
				.catch(error => {
					this.growl.show({ severity: 'error', summary: error.message });
					this.setState({
						isLoading: false
					});
				});
		}
	}

	setCurrentlaboratoryResult(laboratoryResult: UserLaboratoryResultModel) {
		this.setState({ currentlaboratoryResult: { ...laboratoryResult } });
	}

	showEditDialog = (show: boolean) => {
		this.setState({
			isVisibleDialog: show
		});
	};

	handleViewClick = id => {
		this.setState({
			isLoading: true
		});
		this.laboratoryResultsService.getlaboratoryResult(id)
			.then(
				(data) => {
					this.setCurrentlaboratoryResult(data.userLaboratoryResult);
					this.setState({
						isLoading: false,
						isVisibleView: true
					});
				},
				error => {
					this.growl.show({ severity: 'error', summary: error.message });
					this.setState({
						isLoading: false
					});
				}
			);
	}

	handleAddAndEditClick = id => {
		if (!id) { // Add
			this.setCurrentlaboratoryResult(new UserLaboratoryResultModel());
			this.setState({
				dialogHeader: Translate('Add Laboratory result')
			});
			this.showEditDialog(true);
		} else { // Edit
			this.setState({
				isLoading: true,
				dialogHeader: Translate('Edit laboratory Result')
			});
			this.laboratoryResultsService.getlaboratoryResult(id)
				.then(
					(data) => {
						this.setCurrentlaboratoryResult(data.userLaboratoryResult);
						this.showEditDialog(true);
						this.setState({
							isLoading: false
						});
					},
					error => {
						this.growl.show({ severity: 'error', summary: error.message });
						this.setState({
							isLoading: false
						});
					}
				);
		}
	};

	getCondtionTypes(type: LaboratoryTestType, list: Array<LaboratoryResultTypeModel>) {
		let condValue: number = 0;
		for (let i = 0; i < list.length; i++) {
			if (list[i].laboratoryResultTypeId === type) {
				condValue = list[i].laboratoryResultTypeValue;
			}
		}
		return condValue;
	}


	handleCloseAddEditClick = () => {
		this.setState({
			isVisibleDialog: false
		});
	}

	handleAddEditSaveClick = (laboratoryResult: UserLaboratoryResultModel, close: boolean) => {
		this.setState({
			isLoading: true
		});
		if (!laboratoryResult.userLaboratoryResultId || laboratoryResult.userLaboratoryResultId <= 0) {
			this.laboratoryResultsService.addlaboratoryResults(laboratoryResult)
				.then(
					(data) => {
						if (close) {
							this.handleCloseAddEditClick();
						}
						this.growl.show({ severity: 'success', summary: Translate('Data Saved Successfully') });
						this.setCurrentlaboratoryResult(new UserLaboratoryResultModel);
						this.setState({ first: 0 }, () => this.getlaboratoryResults(true));
					},
					error => {
						this.handleCloseAddEditClick();
						this.setCurrentlaboratoryResult(new UserLaboratoryResultModel);
						this.growl.show({ severity: 'error', summary: error.message });
						this.setState({
							isLoading: false
						});
					}
				);
		}
		else {
			this.laboratoryResultsService.updatelaboratoryResults(laboratoryResult.userLaboratoryResultId, laboratoryResult)
				.then(
					(data) => {
						if (close) {
							this.handleCloseAddEditClick();
						}
						this.growl.show({ severity: 'success', summary: Translate('Data Saved Successfully') });
						this.setCurrentlaboratoryResult(new UserLaboratoryResultModel);
						this.setState({ first: 0 }, () => this.getlaboratoryResults(true));
					},
					error => {
						this.handleCloseAddEditClick();
						this.setCurrentlaboratoryResult(new UserLaboratoryResultModel);
						this.growl.show({ severity: 'error', summary: error.message });
						this.setState({
							isLoading: false
						});
					}
				);

		}
	}

	handleDeleteClick = (laboratoryResultId: number, laboratoryResultDate: string) => {
		this.setState({
			isVisibleConfirmDialog: true,
			selectedLaboratoryResultId: laboratoryResultId,
			deleteValidationMessage: Translate('LaboratoryResultConfirm') +
				fomatDateTimeAsStringWithLang(new Date(laboratoryResultDate), this.props.lang) + '?'
		});
	}

	deletelaboratoryResult = (id: number) => {
		this.setState({
			isVisibleConfirmDialog: false,
			isLoading: true
		});

		this.laboratoryResultsService.deletelaboratoryResult(id)
			.then(
				data => {
					this.growl.show({ severity: 'success', summary: Translate('Deleted Successfully') });
					this.setState({ first: 0 }, () => this.getlaboratoryResults(true));
				},
				error => {
					this.growl.show({ severity: 'error', summary: Translate(error.message) });
					this.setState({
						isLoading: false
					});
				});
	}

	paginatorClick = (e, isInit: boolean) => {
		this.setState({ first: e.first }, () => this.getlaboratoryResults(isInit));
	}

	handleChange = (key, value) => {
		const userFilter: UserLaboratoryResultFilterModel = { ...this.state.currentFilters };
		userFilter[key] = value;
		this.setState({ currentFilters: { ...userFilter } })
	};

	handleCloseView = () => {
		this.setState({ isVisibleView: false });
	}

	expandedData = (rowData: UserLaboratoryResultModel) => {
		return (
			<div className="item-actions-panel">
				{/* <button
					data-tip={Translate('UserInfo')}
					type="button"
					className="item-actions-panel-buttons btn-info"
					onClick={() => this.handleViewClick(rowData.userlaboratoryResultId)}
				><i style={{ verticalAlign: 'text-top' }} className="pi pi-ellipsis-h"></i></button> */}

				<button
					type="button"
					className="item-actions-panel-buttons btn-warning"
					onClick={() => this.handleAddAndEditClick(rowData.userLaboratoryResultId)}
					style={{ width: 50 }}
				> <i style={{ verticalAlign: 'text-top' }} className="pi pi-pencil"></i></button>
				<button
					type="button"
					className="item-actions-panel-buttons btn-danger"
					onClick={() => this.handleDeleteClick(rowData.userLaboratoryResultId, rowData.laboratoryResultDate)}
					style={{ width: 50 }}
				><i style={{ verticalAlign: 'text-top' }} className="pi pi-trash"></i></button>
			</div>
		)
	}

	rowExpansionTemplate = (rowData: UserLaboratoryResultModel) => {

		return (
			<CSSTransition in={this.state.expandedLaboratoryResult.some(r => r.userLaboratoryResultId == rowData.userLaboratoryResultId)}
				timeout={300} classNames="list-slide" mountOnEnter unmountOnExit>
				{this.expandedData(rowData)}
			</CSSTransition>
		);
	}

	expandData = (data: UserLaboratoryResultModel) => {
		if (!this.state.expandedLaboratoryResult.some(r => r.userLaboratoryResultId == data.userLaboratoryResultId) || this.state.expandedLaboratoryResult.length == 0) {
			this.setState({ expandedLaboratoryResult: [...this.state.expandedLaboratoryResult, data] });
		} else {
			this.setState({ expandedLaboratoryResult: this.state.expandedLaboratoryResult.filter(r => r.userLaboratoryResultId != data.userLaboratoryResultId) });
		}
	}

	handleExpandChange = panel => (event, expanded) => {
		this.setState({
			expanded: expanded ? panel : false,
		});
	};

	toggleDrawer = (open) => {
		this.setState({
			drawer: open
		});
	};

	handleFilter = (e) => {
		e.preventDefault();
		let filters = { ...this.state.currentFilters };
		let cond = this.state.currentlaboratoryResultValue > 0 ? this.state.currentlaboratoryResultValue : 0;
		this.setState({ drawer: false, filters: filters, selectedLaboratoryResultValue: cond, first: 0, filterByDates: true }, () => this.getlaboratoryResults(true));
	}

	showFilters = () => {
		let currentSettings: UserLaboratoryResultFilterModel = new UserLaboratoryResultFilterModel();
		if (this.state.filters &&
			(this.state.filters.endDate || this.state.filters.startDate)) {
			currentSettings = { ...this.state.filters };
		}

		let timeDr = new Array<DropdownModel>(0);
		timeDr = HelperFunctions.enumToDropdownArray(TimePresetType, true);

		let cond = this.state.selectedLaboratoryResultValue > 0 ? this.state.selectedLaboratoryResultValue : 0;
		this.setState({ drawer: true, currentFilters: { ...currentSettings }, currentlaboratoryResultValue: cond, timeDropdown: timeDr });
	}

	getFiltersummary = () => {
		let nameSet: any = null;
		let startSet: any = null;
		let endSet: any = null;

		if (this.state.selectedLaboratoryResultValue > 0) {
			let name: string = '';
			for (let cond of this.state.laboratoryResultType) {
				if (cond.value == this.state.selectedLaboratoryResultValue) {
					name = cond.label
				}
			}
			nameSet =
				<>
					<span style={{ color: '#999' }}>{Translate('LabTest')}</span>:
					<span style={{ fontWeight: 600 }}> {name} </span>
				</>
		}

		if (this.state.filters && this.state.filters.startDate) {
			startSet =
				<>
					<span style={{ color: '#999' }}>{Translate('From')}</span>:
					<span style={{ fontWeight: 600 }}> {HelperFunctions.fomatDateAsStringWithLang(new Date(this.state.filters.startDate), this.props.lang)} </span>
				</>
		}

		if (this.state.filters && this.state.filters.endDate) {
			endSet =
				<>
					<span style={{ color: '#999' }}>{Translate('To')}</span>:
					<span style={{ fontWeight: 600 }}> {HelperFunctions.fomatDateAsStringWithLang(new Date(this.state.filters.endDate), this.props.lang)} </span>
				</>
		}

		let summary =
			<p style={{ marginTop: 0 }}>
				{nameSet}
				{startSet}
				{endSet}
			</p>

		return summary;
	}

	clearFilters = (e?) => {
		if (e) {
			e.preventDefault();
		}
		this.setState({
			first: 0,
			drawer: false, filters: new UserLaboratoryResultFilterModel(),
			currentFilters: new UserLaboratoryResultFilterModel(),
			selectedLaboratoryResultValue: 0, currentlaboratoryResultValue: 0,
			filterByDates: false,
			selectedTime: 1,
		}, () => this.getlaboratoryResults(true));
	}

	getMonthEarlier = (currentDate: string) => {
		let d = new Date(currentDate);
		d.setMonth(d.getMonth() - 1);
		return d;
	}

	handleDropChange = (cond) => {
		this.setState({ currentlaboratoryResultValue: cond });
	}

	downloadFile = (fileId) => {
		if (fileId && fileId > 0) {
			this.fileService.getFile(fileId)
				.then(
					(data) => {
						let res = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
						FileSaver.saveAs(res);
					},
					error => {
						this.growl.show({ severity: 'error', summary: error.message });
						this.setState({
							isLoading: false
						});
					}
				);
		}
	}

	handleTimeDropdownChange = (id) => {
		let filters = { ...this.state.currentFilters };
		let canChooseDates = false;
		switch (id) {
			case TimePresetType.OneDay:
				filters.startDate = HelperFunctions.getDaysEarlier(new Date().toString(), 1).toISOString();
				filters.endDate = new Date().toISOString();
				canChooseDates = false;
				break;
			case TimePresetType.OneWeek:
				filters.startDate = HelperFunctions.getDaysEarlier(new Date().toString(), 7).toISOString();
				filters.endDate = new Date().toISOString();
				canChooseDates = false;
				break;
			case TimePresetType.OneMonth:
				filters.startDate = HelperFunctions.getMonthsEarlier(new Date().toString(), 1).toISOString();
				filters.endDate = new Date().toISOString();
				canChooseDates = false;
				break;
			case TimePresetType.ThreeMonths:
				filters.startDate = HelperFunctions.getMonthsEarlier(new Date().toString(), 3).toISOString();
				filters.endDate = new Date().toISOString();
				canChooseDates = false;
				break;
			case TimePresetType.SixMonths:
				filters.startDate = HelperFunctions.getMonthsEarlier(new Date().toString(), 6).toISOString();
				filters.endDate = new Date().toISOString();
				canChooseDates = false;
				break;
			case TimePresetType.OneYear:
				filters.startDate = HelperFunctions.getMonthsEarlier(new Date().toString(), 12).toISOString();
				filters.endDate = new Date().toISOString();
				canChooseDates = false;
				break;
			case TimePresetType.Advanced:
				canChooseDates = true;
		}
		this.setState({ selectedTime: id, currentFilters: filters, canChooseDates: canChooseDates });
	}

	keyItem = (m: UserLaboratoryResultModel) => {
		return m.userLaboratoryResultId + 'cond';
	}

	itemName = (m: UserLaboratoryResultModel) => {
		return (
			<span style={{ fontWeight: 600 }}>
				{HelperFunctions.fomatDateTimeAsStringWithLang(new Date(m.laboratoryResultDate), this.props.lang)}
			</span>)
	}

	itemDesc = (m: UserLaboratoryResultModel) => {
		return (
			<>
				{m.userLaboratoryResultTypes && m.userLaboratoryResultTypes.length > 0 ? m.userLaboratoryResultTypes.map(u =>
					<div key={u.isSystemType ? u.laboratoryResultTypeId + 'condType' : u.laboratoryResultTypeId + 'personal'} style={{ width: '100%' }}>
						{u.isSystemType ?
							<>
								<div style={{ color: u.laboratoryResultTypeId == this.state.selectedLaboratoryResultValue ? 'red' : '#999' }}>
									{HelperFunctions.getEnumLabel(u.laboratoryResultTypeId, LaboratoryTestType, true)}:
                                            <span style={{ color: '#444' }}> {u.laboratoryResultTypeValue} {u.laboratoryResultTypeUnit}</span>
								</div>
							</>
							:
							<div>
								{u.personalLaboratoryResult}: <span style={{ color: '#444' }}> {u.laboratoryResultTypeValue}</span>
							</div>}
					</div>) : null}
				{m.fileResults && m.fileResults.length > 0 ?
					<div className="item-desc-info">
						<FontAwesomeIcon style={{ width: '24px' }} icon={faFile} />
						{Translate('Files')}
						<div className="badge text-badge">
							{m.fileResults.length ? m.fileResults.length : '0'}
						</div>
					</div>
					: null}
			</>
		)
	}

	itemActions = (m: UserLaboratoryResultModel) => {
		return (
			<>
				{window.innerWidth >= Constants.device.tablet ? this.expandedData(m) :

					this.state.expandedLaboratoryResult.some(r => r.userLaboratoryResultId == m.userLaboratoryResultId) ?
						<FontAwesomeIcon icon={faChevronUp} />
						: <FontAwesomeIcon icon={faChevronDown} />
				}
			</>
		)
	}

	public render() {
		const { isLoading, isVisibleDialog, currentlaboratoryResult, userLaboratoryResults, filters, expanded,
			dialogHeader, selectedLaboratoryResultId, first, rows, totalRecords, laboratoryResultType,
			isVisibleView, expandedLaboratoryResult, tabActiveIndex, selectedLaboratoryResultValue, selectedTime, timeDropdown } = this.state;

		let showAllLink = false;
		if (filters.startDate || filters.endDate || selectedLaboratoryResultValue > 0) {
			showAllLink = true
		}

		let laboratoryResults = JSON.parse(JSON.stringify(userLaboratoryResults));
		let charts: any = null;
		// if (this.state.selectedLaboratoryResultValue > 0 && userLaboratoryResults.length > 1 && !isLoading) {
		// 	for (let cond of laboratoryResults) {
		// 		cond.userlaboratoryResultTypes = cond.userlaboratoryResultTypes
		// 			.filter(r => r.isSystemType ? r.userlaboratoryResultTypeId == this.state.selectedLaboratoryResultValue : r.userlaboratoryResultTypeId == this.state.selectedLaboratoryResultValue - 1000);
		// 	}
		// 	charts =
		// 		<div style={{ height: '400px' }}>
		// 			<UserlaboratoryResultCharts
		// 				userlaboratoryResults={laboratoryResults}
		// 				lang={this.props.lang}
		// 			/>
		// 		</div>;
		// }

		return (
			<div className="app-content">
				<div>

					<Growl ref={(el) => this.growl = el} />
					<h2>{Translate('Laboratory result')}</h2>

					{charts}

					<Fab focusRipple={false} color="primary" aria-label="Add" size="small" onClick={() => this.handleAddAndEditClick(null)} className="floating-action-button">
						<AddIcon />
					</Fab>
					<Fab color="primary" focusRipple={false} aria-label="Search" size="small" onClick={() => this.showFilters()} className="floating-action-button-second">
						<FontAwesomeIcon icon={faFilter} />
					</Fab>
					<Dialog
						open={this.state.drawer}
						onClose={() => this.toggleDrawer(false)}
						fullWidth={window.innerWidth < Constants.device.desktop}
						aria-labelledby="responsive-dialog-title"
					>

						<Modal.DialogTitle id="customized-dialog-title" onClose={() => this.toggleDrawer(false)}>{Translate('Filters')}</Modal.DialogTitle>
						<Modal.DialogContent>
							<div style={{ minHeight: 200, minWidth: window.innerWidth < Constants.device.desktop ? 'unset' : 400 }}>


								<div className="p-col-12 p-md-12 pl-0 pb-20">
									<FormControl>
										<InputLabel htmlFor="relatiom-label">{Translate('LabTest')}</InputLabel>
										<Select
											value={this.state.currentlaboratoryResultValue ? this.state.currentlaboratoryResultValue : ''}
											onChange={(e) => this.handleDropChange(e.target.value)}
											inputProps={{
												id: 'laboratoryResult-label'
											}}
										>
											{
												laboratoryResultType.map(m => <MenuItem key={m.value + 'condt'} value={m.value}>
													{m.value ? m.label : <em>{m.label}</em>}</MenuItem>)
											}
										</Select>
									</FormControl>
								</div>

								<div style={{ marginBottom: 15 }}>
									<FormControl>
										<InputLabel htmlFor="preset-type-label">{Translate('Period')}</InputLabel>
										<Select
											value={selectedTime}
											onChange={(e) => this.handleTimeDropdownChange(e.target.value)}
											inputProps={{
												id: 'preset-type-label'
											}}>
											{timeDropdown.map(m => <MenuItem key={m.value + 'timeItem'}
												value={m.value}>{m.value ? m.label : <em>{m.label}</em>}</MenuItem>)}
										</Select>
									</FormControl>
								</div>
								{this.state.canChooseDates ?
									<>
										<div style={{ marginBottom: 15 }}>
											<label style={{ width: '100%' }}>{Translate('From')}:</label>
											<MuiPickersUtilsProvider utils={DateFnsUtils}>
												<DatePicker
													format={Translate('DateFormat')}
													margin="normal"
													value={this.state.currentFilters.startDate ? new Date(this.state.currentFilters.startDate) : HelperFunctions.getDaysEarlier(new Date().toString(), 1)}
													onChange={(e) => this.handleChange('startDate', e)}
												/>
											</MuiPickersUtilsProvider>
										</div>
										<div>
											<label style={{ width: '100%' }}>{Translate('To')}:</label>
											<MuiPickersUtilsProvider utils={DateFnsUtils}>
												<DatePicker
													format={Translate('DateFormat')}
													margin="normal"
													value={this.state.currentFilters.endDate ? new Date(this.state.currentFilters.endDate) : new Date()}
													onChange={(e) => this.handleChange('endDate', e)}
												/>
											</MuiPickersUtilsProvider>
										</div>
									</> :
									<>
										<div style={{ marginBottom: 15, display: 'flex', alignItems: 'flex-end' }}>
											<label style={{ width: 'unset', marginRight: 10 }}>{Translate('From')}:</label>
											<div style={{ fontSize: 15 }}>
												{HelperFunctions.fomatDateAsStringWithLang(this.state.currentFilters.startDate ?
													new Date(this.state.currentFilters.startDate) : HelperFunctions.getDaysEarlier(new Date().toString(), 1), this.props.lang)}
											</div>
										</div>
										<div style={{ display: 'flex', alignItems: 'flex-end' }}>
											<label style={{ width: 'unset', marginRight: 10 }}>{Translate('To')}:</label>
											<div style={{ fontSize: 15 }}>
												{HelperFunctions.fomatDateAsStringWithLang(this.state.currentFilters.endDate ?
													new Date(this.state.currentFilters.endDate) : new Date(), this.props.lang)}
											</div>
										</div>
									</>
								}
							</div>
						</Modal.DialogContent>
						<Modal.DialogActions>
							<div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
								<div>
									<Button variant="contained" size="small" color="secondary"
										onClick={this.clearFilters}>
										<FontAwesomeIcon icon={faTimes} style={{ marginRight: '5px' }} />
										{Translate('Clear')}
									</Button>
								</div>
								<div>
									<Button variant="contained" size="small" onClick={() => this.setState({ drawer: false })} style={{ marginRight: '5px' }}>
										<FontAwesomeIcon icon={faTimes} style={{ marginRight: '5px' }} />
										{Translate('Cancel')}
									</Button>
									<Button variant="contained" size="small" color="primary" onClick={(e) => this.handleFilter(e)}>
										<FontAwesomeIcon icon={faFilter} style={{ marginRight: '5px' }} />
										{Translate('Filtering')}
									</Button>
								</div>
							</div>
						</Modal.DialogActions>
					</Dialog>
					<div className="user-laboratoryResult-grid">

						{filters && (filters.startDate || filters.endDate || selectedLaboratoryResultValue > 0) ?
							<>
								<p style={{ marginBottom: 0, fontWeight: 600 }}>{Translate('Filters') + ":"}</p>
								{this.getFiltersummary()}
							</>
							: null}

						{showAllLink ?
							<div style={{ margin: '10px 0' }}>
								<a href='' onClick={(e) => this.clearFilters(e)}>{Translate('See All')}</a>
							</div> : null}

						<ExpandingList
							listItems={userLaboratoryResults}
							keyItem={this.keyItem}
							expandData={this.expandData}
							expandedPanel={this.rowExpansionTemplate}
							itemName={this.itemName}
							itemDesc={this.itemDesc}
							itemActions={this.itemActions}
							isExpandable={window.innerWidth < Constants.device.tablet}
							infoStyle={window.innerWidth < Constants.device.tablet ? {} : { width: 'unset' }}
						/>

						{/* <LaboratoryResultsList laboratoryResults={userLaboratoryResults}
							lang={this.props.lang}
							filterByType={filters.userLaboratoryResultType}
							expandData={this.expandData}
							rowExpansionTemplate={this.rowExpansionTemplate}
							expandedLaboratoryResult={expandedLaboratoryResult}
							downloadFile={this.downloadFile} /> */}
					</div>
					{/* {totalRecords > rows ?
                        <Paginator totalRecords={totalRecords} first={first} rows={rows} onPageChange={(e) => this.paginatorClick(e)}></Paginator>
                        : null} */}
					{isLoading ? <Spinner inlineSpinner={true} /> : null}
					{!isLoading && (!userLaboratoryResults || userLaboratoryResults.length == 0) ? Translate("No records found") : null}
				</div>

				{isVisibleDialog ? <LaboratoryResultAddEditDialog isVisible={isVisibleDialog}
					saveClick={this.handleAddEditSaveClick}
					cancelClick={this.handleCloseAddEditClick}
					selectedLaboratoryResult={currentlaboratoryResult}
					dialogHeader={dialogHeader}></LaboratoryResultAddEditDialog>
					: null}

				<ConfirmDialog
					headerTitle={Translate("Confirm Dialog")}
					isVisible={this.state.isVisibleConfirmDialog}
					yesClick={() => { this.deletelaboratoryResult(selectedLaboratoryResultId) }}
					noClick={() => { this.setState({ isVisibleConfirmDialog: false, deleteValidationMessage: '' }) }}>
					{this.state.deleteValidationMessage}
				</ConfirmDialog>
			</div>
		)
	}
}

class LaboratoryResultDropdownModel {
	value: number;
	label: string;
	isSystem: boolean;
}

const mapsStateToProps = state => {
	return {
		lang: state.common.lang
	};
}

export default connect(mapsStateToProps)(UserlaboratoryResultComponent);